import { C } from '../actions/index';

const initialStylequizState = {
  rooms: [],
  error: null,
  selectedRooms: {},
  currentRoomIndex: 0,
  productSelections: {},
  shuffledProductsList: [],
  styleQuizResults: null,
  signupRequired: false,
  spaceId: null,
  resultsError: null,
  resultsPending: false,
  userInfo: {
    zipcode: '', age: 0, segment: 0, homeType: 0, room: 1
  },
  choice: 0,
  showPoll: false,
  selectedDesignProject: 0
};

export const stylequiz = (state = initialStylequizState, action) => {
  switch (action.type) {
    case C.FETCH_STYLE_QUIZ_ROOMS:
      return Object.assign({}, state, { rooms: action.payload });
    case C.FETCH_STYLE_QUIZ_ROOMS_FAIL:
      return Object.assign({}, state, { error: action.error });
    case C.SELECT_ROOM: {
      const selectedRooms = Object.assign({}, state.selectedRooms);
      if (Object.keys(selectedRooms).length >= 3) {
        return state;
      }
      const selectedRoom = state.rooms.find(room => room.id === action.payload);
      selectedRooms[action.payload] = selectedRoom;
      return Object.assign({}, state, { selectedRooms, currentRoomIndex: 0 });
    }
    case C.UN_SELECT_ROOM: {
      const selectedRooms = Object.assign({}, state.selectedRooms);
      delete selectedRooms[action.payload];
      return Object.assign({}, state, { selectedRooms });
    }
    case C.LIKE_PRODUCT: {
      const productSelections = Object.assign({}, state.productSelections);
      if (productSelections[action.payload]) {
        delete productSelections[action.payload];
      } else {
        productSelections[action.payload] = true;
      }

      return Object.assign({}, state, { productSelections });
    }
    case C.DISLIKE_PRODUCT: {
      const productSelections = Object.assign({}, state.productSelections);
      if (
        productSelections[action.payload] ||
        typeof productSelections[action.payload] === 'undefined'
      ) {
        productSelections[action.payload] = false;
      } else {
        delete productSelections[action.payload];
      }

      return Object.assign({}, state, { productSelections });
    }
    case C.SHUFFLED_PRODUCT: {
      return Object.assign({}, state, { shuffledProductsList: action.payload });
    }
    case C.CLEAR_STYLEQUIZ_PRODUCTS:
      return Object.assign({}, state, { productSelections: {} });
    case C.CHANGE_ROOM_INDEX:
      return Object.assign({}, state, { currentRoomIndex: action.payload });
    case C.COMPLETE_STYLE_QUIZ:
      if (action.payload) {
        return Object.assign({}, state, { resultsPending: true });
      }
      return Object.assign({}, state, { signupRequired: true });

    case C.SUBMIT_STYLE_QUIZ_SUCCESS: {
      const results = {
        styleResult: action.payload.result[1].fields.styleResult,
        description: action.payload.result[1].fields.description,
        picture: action.payload.result[1].fields.picture,
        style1: action.payload.result[0].fields.style_1,
        style2: action.payload.result[0].fields.style_2,
        style3: action.payload.result[0].fields.style_3,
        tips: action.payload.result[1].fields.tips,
        pk: action.payload.result[0].pk,
        renders: action.payload.renders,
        suggestedImages: action.payload.images
      };

      return Object.assign({}, state, {
        signupRequired: false,
        styleQuizResults: results,
        resultsPending: false,
        productSelections: {},
        selectedRooms: {},
        showPoll: action.payload.result[0].fields.poll_alignment === '0'
      });
    }
    case C.FETCH_STYLE_QUIZ_RESULTS: {
      const results = {
        styleResult: action.payload.result[1].fields.styleResult,
        description: action.payload.result[1].fields.description,
        picture: action.payload.result[1].fields.picture,
        style1: action.payload.result[0].fields.style_1,
        style2: action.payload.result[0].fields.style_2,
        style3: action.payload.result[0].fields.style_3,
        tips: action.payload.result[1].fields.tips,
        pk: action.payload.result[0].pk,
        renders: action.payload.renders,
        suggestedImages: action.payload.images
      };

      return Object.assign({}, state, {
        signupRequired: false,
        styleQuizResults: results,
        resultsPending: false,
        productSelections: {},
        selectedRooms: {},
        showPoll: action.payload.result[0].fields.poll_alignment === '0'
      });
    }
    case C.SET_SQ_SPACE_ID:
      return Object.assign({}, state, { spaceId: action.payload });
    case C.STYLE_QUIZ_RESULTS_ERROR:
      return Object.assign({}, state, {
        resultsError: action.error,
        resultsPending: false
      });
    case C.UPDATE_USER_INFO: {
      const userInfo = Object.assign({}, state.userInfo);
      userInfo[action.payload.field] = action.payload.newValue;
      return Object.assign({}, state, { userInfo });
    }
    case C.CHANGE_POLL_CHOICE:
      return Object.assign({}, state, { choice: action.payload });
    case C.SUBMIT_STYLE_QUIZ_POLL:
      return Object.assign({}, state, { showPoll: false });
    case C.SET_DESIGN_PROJECT: {
      return Object.assign({}, state, {
        selectedDesignProject: action.payload
      });
    }
    default:
      return state;
  }
};
